import { HttpRequest } from "@/utils/request"

export type FeedbackStatus = "new" | "in_progress" | "resolved" | "rejected"

export interface FeedbackData {
  id: number
  message: string
  name?: string | null
  contact?: string | null
  url: string
  user_agent?: string | null
  ip_address?: string | null
  user_id?: number | null
  status: FeedbackStatus
  images?: string[] | null
  images_url?: string[]
  created_at?: string
  updated_at?: string
  user?: any
}

export const feedbackService = {
  list(params: any) {
    return HttpRequest.get("v1/feedbacks", {
      searchParams: params as any,
    }).json<{
      code: number
      data: FeedbackData[]
      total: number
      page: number
      limit: number
    }>()
  },
  updateStatus(id: number | string, status: FeedbackStatus) {
    return HttpRequest.put(`v1/feedbacks/${id}/status`, {
      json: { status },
    }).json<{
      code: number
      message: string
      data: FeedbackData
    }>()
  },
}
